import api from "services/api";

const API_URL = process.env.REACT_APP_API_URL || "";

export async function fetchPersonnel(
  pageSize,
  pageNumber,
  searchTerm,
  sortColumn,
  sortDirection,
  isActive = null // Thêm tham số isActive để lọc theo trạng thái
) {
  try {
    const params = {
      pageSize,
      pageNumber,
      searchTerm,
      sortColumn,
      sortDirection,
    };

    // Thêm tham số isActive nếu được cung cấp
    if (isActive !== null && isActive !== undefined) {
      params.isActive = isActive;
    }

    const response = await api.get(`/Personnel`, { params });
    // Chuẩn hóa lấy đúng trường data và totalCount
    if (response.data && Array.isArray(response.data.data)) {
      return {
        items: response.data.data,
        totalItems: response.data.totalCount || response.data.data.length,
      };
    }
    return { items: [], totalItems: 0 };
  } catch (err) {
    return { items: [], totalItems: 0 };
  }
}

export async function getPersonnelById(id) {
  try {
    const response = await api.get(`/Personnel/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
}

export async function createPersonnel(data) {
  try {
    const response = await api.post("/Personnel", data);
    return response;
  } catch (err) {
    throw err;
  }
}

export async function updatePersonnel(id, data) {
  try {
    const response = await api.put(`/Personnel/${id}`, data);
    return response;
  } catch (err) {
    throw err;
  }
}

export async function updatePersonnelStatus(id, isActive) {
  try {
    const response = await api.patch(`/Personnel/${id}/status`, { isActive });
    return response;
  } catch (err) {
    throw err;
  }
}

// Cache cho qualifications để tránh gọi API nhiều lần
const qualificationsCache = new Map();

// Thêm function để lấy qualifications cho một personnel
export async function getPersonnelQualifications(personnelId) {
  try {
    // Kiểm tra cache trước
    if (qualificationsCache.has(personnelId)) {
      return qualificationsCache.get(personnelId);
    }

    const params = { pageSize: 100, pageNumber: 1 };
    const response = await api.get(`/Qualification/personnel/${personnelId}`, {
      params,
    });

    // Kiểm tra cả 2 trường hợp: data và Data
    const responseData = response.data.data || response.data.Data;
    if (response.data && responseData) {
      const qualifications =
        responseData.map((q) => ({
          qualificationName: q.qualificationName || "",
          majorName: q.major || "", // Đặt majorName để khớp với PersonnelList
          major: q.major || "", // Giữ lại major để tương thích
          graduationYear: q.graduationYear
            ? new Date(q.graduationYear).getFullYear().toString()
            : "",
          qualificationId: q.qualificationId,
        })) || [];

      // Lưu vào cache
      qualificationsCache.set(personnelId, qualifications);
      return qualifications;
    }
    return [];
  } catch (err) {
    return [];
  }
}

// Function để xóa cache khi cần
export function clearQualificationsCache(personnelId = null) {
  if (personnelId) {
    qualificationsCache.delete(personnelId);
  } else {
    qualificationsCache.clear();
  }
}

// Thêm function để lấy qualifications cho nhiều personnel cùng lúc
export async function getPersonnelsWithQualifications(personnelList) {
  try {
    const personnelWithQualifications = await Promise.all(
      personnelList.map(async (personnel) => {
        try {
          const qualifications = await getPersonnelQualifications(
            personnel.personnelId
          );
          return {
            ...personnel,
            qualifications: qualifications,
          };
        } catch (error) {
          // Chỉ trả về personnel với qualifications rỗng, không log error
          return {
            ...personnel,
            qualifications: [],
          };
        }
      })
    );

 

    return personnelWithQualifications;
  } catch (err) {
    console.error("Error in getPersonnelsWithQualifications:", err);
    // Trả về danh sách với qualifications rỗng thay vì log error
    return personnelList.map((p) => ({ ...p, qualifications: [] }));
  }
}
